import { Flex } from '@bb/elements-web';
import { Button } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import CoopSelectContext from './CoopSelectContext';

const BookForButtons: React.FC = () => {
  const { bookFor, setBookFor, bookForOptions, setCoop } =
    useContext(CoopSelectContext);
  const hasSelf = bookForOptions.includes('self');
  const hasRosterLookup = bookForOptions.includes('otherAgent');
  const hasNonRosterLookup = bookForOptions.includes('nonAgent');
  if (+hasSelf + +hasRosterLookup + +hasNonRosterLookup === 1) return null;

  const isSelf = bookFor === 'self';
  const isRosterLookup =
    bookFor === 'otherAgent' || bookFor === 'customAgentCreate';
  const isNonRosterLookup =
    bookFor === 'nonAgent' || bookFor === 'nonAgentCreate';

  return (
    <StyledFlex justify="space-around">
      {hasSelf && (
        <Button
          onClick={() => setBookFor('self')}
          type={isSelf ? 'primary' : 'default'}
          data-cy="bookFor-self-btn"
        >
          Book For Myself
        </Button>
      )}
      {hasSelf && hasRosterLookup && (
        <Button
          onClick={() => {
            setBookFor('otherAgent');
            setCoop(null);
          }}
          type={isRosterLookup ? 'primary' : 'default'}
          data-cy="bookFor-otherAgent-btn"
        >
          Book For Another Agent
        </Button>
      )}
      {!hasSelf && hasRosterLookup && (
        <Button
          onClick={() => {
            setBookFor('otherAgent');
            setCoop(null);
          }}
          type={isRosterLookup ? 'primary' : 'default'}
          data-cy="bookFor-otherAgent-btn"
        >
          Agent Lookup
        </Button>
      )}
      {hasNonRosterLookup && (
        <Button
          onClick={() => {
            setBookFor('nonAgent');
            setCoop(null);
          }}
          type={isNonRosterLookup ? 'primary' : 'default'}
          data-cy="bookFor-nonAgent-btn"
        >
          Other Profile
        </Button>
      )}
    </StyledFlex>
  );
};

export const StyledFlex = styled(Flex)`
  max-width: 450px;
  width: 90%;
  margin: 0 auto;
`;

export default BookForButtons;
